import { table } from './_table';

export const senders = {
  namespaced: true,
  modules: {
    table
  }
};
